import categoriesService from "../../services/dealCategory";
var isTagInCategory = function (category, tagUuid) {
    return category.tags.some(function (tag) { return tag.uuid === tagUuid; });
};
var getCategoryFromTag = function (tagUuid) {
    return categoriesService.listForCurrentPackage().then(function (categories) {
        var dealCategory = categories.find(function (category) { return isTagInCategory(category, tagUuid); });
        return dealCategory;
    });
};
export default getCategoryFromTag;
